const WEBHOOK_URL = "https://hook.us2.make.com/9ab6gooi6xosxajgqgw8li10fm29d8ta";

export const fireRegistrationWebhook = ({ phone_number, email, user_type, event_type = "registration_submitted" }) => {
  fetch(WEBHOOK_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      phone_number,
      event_type,
      email,
      user_type,
    }),
  }).catch(() => {});
};
